
export default {
  maps: {
    pageTitle: 'CycleAI',
    Places: 'Orte',
    isochrones: 'Isochronen',
    placeNameRequired: 'Ortsangabe benötigt',
    altitude: 'Höhenänderung',
    settings: 'Einstellungen',
    toggleAccessibleMode: 'Barrierefreien Modus aktivieren/deaktivieren',
    about: 'Über ors',
    updateSearch: 'Suche in dieser Gegend',
    updateSearchAfterZoomOrCenterChange: 'Suche nach Kartenbewegung aktualisieren'
  }
}
